import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/glacier';
import MapSection from '../components/Maps/glacier';

class GlacierNationalParkMemorialDay extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Glacier National Park Memorial Day Weekend Guide</title>
          <meta name="description" content="Memorial Day weekend guide to Glacier National Park: early-season road closures, fewer crowds, and biking on car-free sections of Going-to-the-Sun Road." />
          <meta property="og:title" content="Glacier National Park Memorial Day Weekend Guide" />
          <meta property="og:description" content="Memorial Day weekend guide to Glacier National Park: early-season road closures, fewer crowds, and biking on car-free sections of Going-to-the-Sun Road." />
          <meta property="og:url" content="https://exploroff.com/itineraries/glacier-national-park-memorial-day" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/glacier-national-park-memorial-day-weekend.png" />
          <link rel="canonical" href="https://exploroff.com/itineraries/glacier-national-park-memorial-day" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Glacier National Park Memorial Day Weekend Guide",
            description: "Memorial Day weekend guide to Glacier National Park: early-season road closures, fewer crowds, and biking on car-free sections of Going-to-the-Sun Road.",
            image: ["https://exploroff.com/img/glacier-national-park-memorial-day-weekend.png"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/glacier-national-park-memorial-day" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Glacier National Park Memorial Day Weekend Guide"
          category="itineraries"
          slug="glacier-national-park-memorial-day"
          excerpt="Early-season road closures, fewer crowds, and biking on car-free Going-to-the-Sun Road make Memorial Day one of the best times to visit."
          tags={['planning', 'photography', 'trail tips']}
          readTime={8}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Glacier Park Lodge', type: 'Historic Lodge · East Glacier', url: 'https://www.booking.com/searchresults.html?ss=East+Glacier+Park%2C+Montana' },
            { name: 'Apgar Village Lodge', type: 'Cabins · West Glacier', url: 'https://www.booking.com/searchresults.html?ss=West+Glacier%2C+Montana' },
            { name: 'Hotels in Whitefish', type: 'Gateway Town · 30 min away', url: 'https://www.booking.com/searchresults.html?ss=Whitefish%2C+Montana' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default GlacierNationalParkMemorialDay;
